export const RE_INITIALIZE_ON_EMBED_ADD = false;
export const HYDRATION_KEY = '__ksys-app-hydration__';
export const PREVIEW_CONTEXT_KEY = '__ksys-app-preview-context__';
//# sourceMappingURL=index.js.map